import { Controller } from "@hotwired/stimulus"

// Sort dropdown + grid/table toggle for the labels index. Each action submits the
// GET form, which keeps params in sync and advances the URL; search uses table-search.
export default class extends Controller {
  static targets = ["form", "sort", "sortInput", "sortLabel", "viewInput", "toggle"]
  static values = { frame: { type: String, default: "labels_content" } }

  connect() {
    this.onFrameLoad = this.syncSortFromFrame.bind(this)
    document.addEventListener("turbo:frame-load", this.onFrameLoad)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  submit(event) {
    if (this.hasFormTarget) this.formTarget.requestSubmit()
    const trigger = event.currentTarget
    if (trigger && typeof trigger.blur === "function") trigger.blur()
  }

  switch(event) {
    event.preventDefault()
    const view = event.currentTarget.dataset.view
    if (!view) return

    if (this.hasViewInputTarget) this.viewInputTarget.value = view
    this.updateToggleState(view)
    this.submit(event)
  }

  selectSort(event) {
    const sort = event.currentTarget.dataset.sort
    if (!sort) return

    if (this.hasSortInputTarget) this.sortInputTarget.value = sort
    if (this.hasSortLabelTarget) this.sortLabelTarget.textContent = event.currentTarget.dataset.label
    this.submit(event)
  }

  updateToggleState(view) {
    this.toggleTargets.forEach((toggle) => {
      const selected = toggle.dataset.view === view
      toggle.classList.toggle("selected", selected)
      toggle.setAttribute("aria-pressed", selected)
    })

    if (this.hasSortTarget) {
      this.sortTarget.classList.toggle("labels-toolbar__sort--hidden", view === "table")
    }
  }

  // Table view sorts via column headers (inside the frame), so keep the dropdown
  // in step with the loaded URL. That way toggling back to grid keeps the sort.
  syncSortFromFrame(event) {
    const frame = event.target
    if (!frame || frame.id !== this.frameValue) return

    const src = frame.getAttribute("src")
    if (!src) return

    const sort = new URL(src, window.location.origin).searchParams.get("sort")
    if (!sort) return

    if (this.hasSortInputTarget) this.sortInputTarget.value = sort
    this.updateSortLabel(sort)
  }

  updateSortLabel(sort) {
    if (!this.hasSortLabelTarget) return

    const item = this.element.querySelector(`[data-sort="${sort}"]`)
    if (item) this.sortLabelTarget.textContent = item.dataset.label
  }
}
